<img
  class="fv-logo"
  [class.fv-logo--inverted]="theme() === 'inverted'"
  [class.fv-logo--sm]="size() === 'sm'"
  [class.fv-logo--md]="size() === 'md'"
  [src]="src()"
  [style.height.px]="logoHeight()"
  alt="Company logo" />
